import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Observable } from 'rxjs';
import {
  ShoppingCartResponse,
  CreateAuthorizedShoppingCartRequest,
  AuthorizedShoppingCart,
} from '../models/order-capture.model';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  getOrCreateShoppingCart(externalShoppingCartId?: string): Observable<ShoppingCartResponse> {
    const url =
      `${this.apiUrl}/shoppingcart` + (externalShoppingCartId ? `?externalShoppingCartId=${externalShoppingCartId}` : '');
    return this.http.get<ShoppingCartResponse>(url);
  }

  createShoppingCart(shoppingCartRequest?: CreateAuthorizedShoppingCartRequest): Observable<AuthorizedShoppingCart> {
    const url = `${this.apiUrl}/shoppingcart`;
    return this.http.post<AuthorizedShoppingCart>(url, shoppingCartRequest);
  }

  authorizeShoppingCart(
    externalShoppingCartId: string,
    shoppingCartRequest?: CreateAuthorizedShoppingCartRequest
  ): Observable<AuthorizedShoppingCart> {
    const url = `${this.apiUrl}/shoppingcart/${externalShoppingCartId}/authorize`;
    return this.http.post<AuthorizedShoppingCart>(url, shoppingCartRequest);
  }

  removeAllItemsFromShoppingCart(externalShoppingCartId: string): Observable<boolean> {
    const url = `${this.apiUrl}/shoppingcart/${externalShoppingCartId}/itemCollection`;
    return this.http.delete<boolean>(url);
  }
}
